<template>
  <div>
    <div class="card-body mt-4">
      <apexchart
          class="apex-charts"
          height="350"
          :series="salesDataSeries"
          :options="salesDataOptions"
      ></apexchart>
    </div>
  </div>
</template>

<script>
export default {
  name: "individualSalesPerformance",
  data(){
    return {

    }
  },
  props: {
    salesDataSeries: {
      type: Array,
      default (){
        return []
      }
    },
    salesDataOptions: {
      type: Object,
      default (){
        return {
          chart: {
            height: 350,
            type: "bar",
          },
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
